import { render, staticRenderFns } from "./preview.vue?vue&type=template&id=222c2cf0&scoped=true&"
import script from "./preview.vue?vue&type=script&lang=js&"
export * from "./preview.vue?vue&type=script&lang=js&"
import style0 from "./preview.vue?vue&type=style&index=0&id=222c2cf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222c2cf0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/builds/master/frontend/frontend-universe/components/SvgIcon.vue').default,LazyLoad: require('/builds/master/frontend/frontend-universe/components/lazy-load.vue').default})
